"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PokerIssuesSortOption = exports.PokerPlanningGameState = exports.PokerGameMetricSystem = exports.PokerGameType = void 0;
var PokerGameType;
(function (PokerGameType) {
    PokerGameType["Fibonacci"] = "Fibonacci";
    PokerGameType["ShortFibonacci"] = "ShortFibonacci";
    PokerGameType["TShirt"] = "TShirt";
    PokerGameType["Scrum"] = "Scrum";
    PokerGameType["Sequential"] = "Sequential";
    PokerGameType["HalfCards"] = "HalfCards";
})(PokerGameType = exports.PokerGameType || (exports.PokerGameType = {}));
var PokerGameMetricSystem;
(function (PokerGameMetricSystem) {
    PokerGameMetricSystem["Average"] = "Average";
    PokerGameMetricSystem["Median"] = "Median";
    PokerGameMetricSystem["Consensus"] = "Consensus";
    PokerGameMetricSystem["MinMax"] = "MinMax";
})(PokerGameMetricSystem = exports.PokerGameMetricSystem || (exports.PokerGameMetricSystem = {}));
var PokerPlanningGameState;
(function (PokerPlanningGameState) {
    PokerPlanningGameState["PreVoting"] = "PreVoting";
    PokerPlanningGameState["Voting"] = "Voting";
    PokerPlanningGameState["PostVoting"] = "PostVoting";
})(PokerPlanningGameState = exports.PokerPlanningGameState || (exports.PokerPlanningGameState = {}));
var PokerIssuesSortOption;
(function (PokerIssuesSortOption) {
    PokerIssuesSortOption["Key"] = "Key";
    PokerIssuesSortOption["Title"] = "Title";
    PokerIssuesSortOption["EstimatedFirst"] = "EstimatedFirst";
    PokerIssuesSortOption["EstimatedLast"] = "EstimatedLast";
})(PokerIssuesSortOption = exports.PokerIssuesSortOption || (exports.PokerIssuesSortOption = {}));
//# sourceMappingURL=planning-poker.js.map